export type TradeType = 'roofing' | 'siding' | 'general';

export interface DamageTypeOption {
  value: string;
  label: string;
}

export const DAMAGE_TYPES: Record<TradeType, DamageTypeOption[]> = {
  roofing: [
    { value: 'hail_damage', label: 'Hail' },
    { value: 'missing_shingle', label: 'Missing Shingle' },
    { value: 'wind_lift', label: 'Wind Lift' },
    { value: 'cracked_tile', label: 'Cracked Tile' },
    { value: 'flashing', label: 'Flashing' },
    { value: 'gutter', label: 'Gutter' },
    { value: 'leak', label: 'Leak' },
    { value: 'vent', label: 'Vent Issue' },
  ],
  siding: [
    { value: 'cracked', label: 'Cracked' },
    { value: 'dent', label: 'Dent' },
    { value: 'missing', label: 'Missing' },
    { value: 'warped', label: 'Warped' },
    { value: 'faded', label: 'Faded' },
    { value: 'hole', label: 'Hole' },
    { value: 'loose', label: 'Loose' },
    { value: 'rot', label: 'Rot' },
  ],
  general: [
    { value: 'impact', label: 'Impact' },
    { value: 'water', label: 'Water' },
    { value: 'structural', label: 'Structural' },
    { value: 'other', label: 'Other' },
  ],
};

export const TRADE_LABELS: Record<TradeType, string> = {
  roofing: 'Roofing',
  siding: 'Siding',
  general: 'General',
};
